import cn from 'classnames';

import { FC, useMemo } from 'react';
import { Route, Switch } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { navigate } from '../../../../processes/navigation';
import { TabContent, Tabs } from '../../../../shared/ui';

import { QUICK_RECORDINGS_ROUTE } from '../../../../entities/history';

import { RecordsMy } from './RecordsMy';
import { RecordsShared } from './RecordsShared';

import { recordingsModel } from '../../model';
import { authUserModel } from '../../../../entities/auth-user';
import { IconMap } from '../../../../shared/sprite';

import { RecordCategory } from '../../../../entities/recordings';
import { useSelectedTab } from '../../../../entities/history';
import { RecordsFilters } from './RecordsFilters';

export const RecordsTabs: FC = () => {
  const dispatch = useDispatch();

  const currentUser = useSelector(authUserModel.selectors.selectUserWithError);

  const hasRecordsShared = useSelector(
    recordingsModel.selectors.selectHasRecordsShared(currentUser.id)
  );

  const hasRecordsMyOnly = useSelector(
    recordingsModel.selectors.selectHasRecordsMyOnly(currentUser.id)
  );

  const tabs = useMemo<TabContent[]>(
    () => [
      {
        name: RecordCategory.MY,
        title: 'My recordings',
        component: <RecordsMy />,
        icon: IconMap.Lead,
      },
      ...(hasRecordsShared
        ? [
            {
              name: RecordCategory.SHARED,
              title: 'Shared with me',
              component: <RecordsShared />,
              icon: IconMap.Building,
            },
          ]
        : []),
    ],
    [hasRecordsShared]
  );

  const { selectedTab } = useSelectedTab(tabs);

  return (
    <div className="flex flex-col flex-grow-1 gap-y-6 sm:pb-0 pb-6">
      <div
        className={cn(
          'flex flex-nowrap items-end gap-4 md:justify-end md:flex-col min-h-10',
          { hidden: hasRecordsMyOnly }
        )}
      >
        <Tabs
          selectedTab={selectedTab}
          tabs={tabs}
          tabsOnly
          onSelectTab={(tab) =>
            dispatch(navigate({ to: `${QUICK_RECORDINGS_ROUTE}/${tab.name}` }))
          }
          className="!mb-0"
        />
        <RecordsFilters type={selectedTab.name as RecordCategory} />
      </div>
      {hasRecordsMyOnly && (
        <RecordsFilters type={selectedTab.name as RecordCategory} />
      )}
      <Switch>
        {tabs.map((tab) => (
          <Route
            path={`${QUICK_RECORDINGS_ROUTE}/${tab.name}`}
            key={tab.name}
            render={() => tab.component}
          />
        ))}
      </Switch>
    </div>
  );
};
